module.exports = __webpack_public_path__ + "static/media/quotation-kwh5.ba52a8a7.jpg";